import React from 'react';
import { 
  Box, Typography, Paper, Table, TableContainer, TableHead, TableRow,
  TableCell, TableBody, Divider
} from '@mui/material';
import { InvoiceDto } from '../../services/expensesApi';
import { formatEuro, formatNumber } from '../../utils/currency';
import { formatDate } from '../../utils/date';

interface InvoiceDetailProps {
  invoice: InvoiceDto;
}

const InvoiceDetail: React.FC<InvoiceDetailProps> = ({ invoice }) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>Detalhes da fatura</Typography>
      
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ mb: 1 }}><strong>Data:</strong> {formatDate(invoice.date)}</Typography>
        {invoice.notes && (
          <Typography sx={{ mb: 1 }}><strong>Notas:</strong> {invoice.notes}</Typography>
        )}
      </Box>

      {invoice.products && invoice.products.length > 0 && (
        <>
          <Typography variant="h6" gutterBottom>Produtos</Typography>
          <TableContainer sx={{ mb: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Produto</TableCell>
                <TableCell align="right">Quantidade</TableCell>
                <TableCell align="right">Preço (sem IVA)</TableCell>
                <TableCell align="right">IVA %</TableCell>
                <TableCell align="right">Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoice.products.map((product, index) => (
                <TableRow key={index}>
                  <TableCell>{product.productName}</TableCell>
                  <TableCell align="right">{product.quantity}</TableCell>
                  <TableCell align="right">{formatEuro(product.priceWithoutIva)}</TableCell>
                  <TableCell align="right">{formatNumber(product.ivaRate, 1)}%</TableCell>
                  <TableCell align="right">
                    <Box sx={{ textAlign: 'right' }}>
                      <Typography variant="body2" color="text.secondary">
                        {formatEuro(product.quantity * product.priceWithoutIva)} (sem IVA)
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        {formatEuro(product.quantity * product.priceWithoutIva * (1 + product.ivaRate / 100))} (com IVA)
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          </TableContainer>
          <Divider sx={{ my: 2 }} />
        </>
      )}

      <Box sx={{ textAlign: 'right' }}>
        <Typography variant="body1" color="text.secondary">
          Total sem IVA: {formatEuro(invoice.products?.reduce((total, product) => 
            total + (product.quantity * product.priceWithoutIva), 0) ?? 0)}
        </Typography>
        <Typography variant="h6">
          <strong>Total com IVA: {formatEuro(invoice.total)}</strong>
        </Typography>
      </Box>
    </Paper>
  );
};

export default InvoiceDetail;
